import React from "react";
import SwimmingSetRow from "../swimming/SwimmingSetRow";
import StrengthExerciseRow from "../strength/StrengthExerciseRow";
import WodMovementRow from "../wod/WodMovementRow";
import RunningSegmentRow from "../running/RunningSegmentRow";

/**
 * Renderiza a linha de série correta com base no tipo de treino.
 */
export const SetRowByType = ({ workoutType, ...props }) => {
    switch (workoutType) {
        case "strength": return <StrengthExerciseRow {...props} />;
        case "running":  return <RunningSegmentRow {...props} />;
        case "wod":      return <WodMovementRow {...props} />;
        default:         return <SwimmingSetRow {...props} />;
    }
};
